import React from 'react';
import PropTypes from 'prop-types';
import './Partner.css';

interface Partner {
  image: string;
  href: string;
}

interface PartnersListingProps {
  title: string;
  partners: Partner[];
}

const PartnersListing: React.FC<PartnersListingProps> = ({ title, partners }) => {
  return (
    <div className="partners-listing">
      <div className="partners-main">
        <h2>{title}</h2>
        <div className="partners-content">
          {Array.from({ length: Math.ceil(partners.length / 4) }, (_, i) => (
            <div key={i} className="partners-row">
              {partners.slice(i * 4, i * 4 + 4).map((partner, index) => (
                <div key={index} className="partner-image-container">
                  <a 
                    className="partner-image" 
                    href={partner.href} 
                    style={{ backgroundImage: `url(${partner.image})` }}
                    aria-label={`Partner ${index + 1}`}
                  ></a>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// Type checking with PropTypes
PartnersListing.propTypes = {
  title: PropTypes.string.isRequired,
  partners: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

export default PartnersListing;